import type { ColDef } from 'ag-grid-community';
import { DateCellRenderer } from '@/components/ag-grid/DateCellRenderer';
import { DurationCellRenderer } from '@/components/ag-grid/DurationCellRenderer';
import { StatusCellRenderer } from '@/components/ag-grid/StatusCellRenderer';
import { truncateText } from '@/utils/formatters';

/**
 * Simplified column definitions for iterations grid (compact view)
 */
const simpleIterationsColDef = (): ColDef[] => {
  const colDef: ColDef[] = [
    { 
      field: 'start', 
      headerName: 'Start Time',
      cellRenderer: DateCellRenderer,
      width: 200,
      sort: 'desc',
      filter: 'agDateColumnFilter',
    },
    { 
      field: 'success', 
      headerName: 'Status',
      cellRenderer: StatusCellRenderer,
      width: 120,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        valueFormatter: (params: any) => params.value ? 'Success' : 'Failed',
      },
      enableRowGroup: true,
    },
    { 
      field: 'totalMs', 
      headerName: 'Duration',
      cellRenderer: DurationCellRenderer,
      width: 120,
      type: 'numericColumn',
      filter: 'agNumberColumnFilter',
      enableValue: true,
    },
    { 
      field: 'entity', 
      headerName: 'Entity',
      width: 150,
      filter: 'agSetColumnFilter',
      enableRowGroup: true,
      enablePivot: true,
    },
    { 
      field: 'tenantId', 
      headerName: 'Tenant',
      width: 120,
      filter: 'agTextColumnFilter',
      enableRowGroup: true,
    },
    { 
      field: 'description', 
      headerName: 'Description',
      flex: 1,
      minWidth: 200,
      filter: 'agTextColumnFilter',
      tooltipField: 'description',
      cellRenderer: (params: any) => truncateText(params.value, 80),
    },
    { 
      field: 'itemsProcessed', 
      headerName: 'Items',
      width: 100,
      type: 'numericColumn',
      filter: 'agNumberColumnFilter',
      enableValue: true,
      cellRenderer: (params: any) => {
        const value = params.value;
        if (value === null || value === undefined) return '0';
        return value.toLocaleString();
      },
    },
  ];
  
  return colDef;
};

export default simpleIterationsColDef;